import type { LinhaMapeada, ResultadoValidacao } from '../../importacao/validacao'
import { agruparErros } from '../../importacao/agruparErros'

interface Props {
  resultado: ResultadoValidacao
  camposVisiveis: string[]
  // Linhas COM preco e SEM comissao na planilha. Contado pelo pai, que sabe se a
  // coluna de comissao foi mapeada. Zero esconde o aviso.
  semComissao?: number
}

const LIMITE_LINHAS_PREVIA = 50

export default function PreviaImportacao({ resultado, camposVisiveis, semComissao = 0 }: Props) {
  return (
    <div className="space-y-3">
      <div className="bg-white rounded-xl shadow-sm p-4">
        <p className="text-sm text-slate-700">
          {/* Singular de verdade: a tela dizia "1 linhas prontas". Numero 1 com
              plural ao lado faz a frase parecer defeito, e quem le passa a
              desconfiar da contagem inteira. */}
          <strong className="text-emerald-700">{resultado.validas.length}</strong>{' '}
          {resultado.validas.length === 1 ? 'linha pronta' : 'linhas prontas'} para
          importar{resultado.erros.length > 0 && (
            <>
              {' '}— <strong className="text-red-600">{resultado.erros.length}</strong>{' '}
              {resultado.erros.length === 1 ? 'com problema (será pulada)' : 'com problema (serão puladas)'}
            </>
          )}
          {/* Sem isto a previa dizia so "N linhas prontas" mesmo com produto sem
              comissao, e a usuaria leu como "o app esta aceitando sem comissao"
              (smoke de 2026-07-28). O texto afirma um FATO da planilha, e nao
              promete o passo de preenchimento: ha caminho em que ele nao roda. */}
          {semComissao > 0 && (
            <> — <strong className="text-amber-700">{semComissao}</strong> sem comissão na planilha</>
          )}
        </p>
      </div>
      {/* Uma entrada por PROBLEMA, nao por linha. Antes saia uma frase por
          linha, cortada em 50 SEM dizer que cortou: com 200 linhas do mesmo
          defeito ela lia 50 frases quase iguais e nao ficava sabendo das
          outras 150. Ver agruparErros.ts. */}
      {resultado.erros.length > 0 && (
        <div className="bg-red-50 border border-red-200 rounded-xl p-4 space-y-2">
          <h4 className="text-sm font-medium text-red-700">
            Linhas com problema — {resultado.erros.length} no total
          </h4>
          {agruparErros(resultado.erros).map((grupo) => (
            <div key={grupo.tipo}>
              <p className="text-sm text-red-700">
                <span aria-hidden="true">⚠ </span>
                {grupo.rotulo} —{' '}
                <strong>
                  {grupo.quantidade} {grupo.quantidade === 1 ? 'linha' : 'linhas'}
                </strong>
              </p>
              {/* break-words: um valor colado da planilha pode ser uma palavra
                  unica longa, e a 360px isso estouraria a caixa. */}
              <p className="text-xs text-red-600 break-words">
                {grupo.exemplos
                  .map((e) => (e.valor === undefined ? `linha ${e.linha}` : `linha ${e.linha} ("${e.valor}")`))
                  .join(', ')}
                {grupo.restantes > 0 && ` … e mais ${grupo.restantes}`}
              </p>
            </div>
          ))}
        </div>
      )}
      <div className="bg-white rounded-xl shadow-sm p-2 overflow-x-auto">
        <table className="text-xs w-full">
          <thead>
            <tr>
              {camposVisiveis.map((campo) => (
                <th key={campo} className="text-left px-2 py-1 text-slate-500">{campo}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {resultado.validas.slice(0, LIMITE_LINHAS_PREVIA).map((linha: LinhaMapeada) => (
              <tr key={linha.indice} className="border-t border-slate-100">
                {camposVisiveis.map((campo) => (
                  <td key={campo} className="px-2 py-1 text-slate-700">{linha.campos[campo] ?? ''}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {resultado.validas.length > LIMITE_LINHAS_PREVIA && (
          <p className="text-xs text-slate-400 p-2">
            Mostrando {LIMITE_LINHAS_PREVIA} de {resultado.validas.length} linhas.
          </p>
        )}
      </div>
    </div>
  )
}
